'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { updateUserLocale } from '../api/update-locale';
import { ApiClientError } from '@/shared/lib/api';
import { toast } from '@/shared/lib/toast';

/**
 * Hook to update user's locale preference
 */
export function useUpdateLocale() {
  const t = useTranslations('i18n');
  const [isUpdating, setIsUpdating] = useState(false);

  const updateLocale = async (locale: string): Promise<boolean> => {
    try {
      setIsUpdating(true);
      await updateUserLocale(locale);
      return true;
    } catch (error) {
      console.error('Failed to update locale:', error);
      toast.error(
        error instanceof ApiClientError
          ? error.getFirstError()
          : t('errorUpdateLocale')
      );
      return false;
    } finally {
      setIsUpdating(false);
    }
  };

  return {
    updateLocale,
    isUpdating,
  };
}
